import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {
    @Input() size = '3.2rem';

    constructor() {
    }

    ngOnInit() {
    }

}
